import React, { useEffect, useState, useRef } from 'react';

export default function Panel({ onLogout }) {
  const [status, setStatus] = useState("idle");
  const [log, setLog] = useState([]);
  const pollingRef = useRef(null);
  const [backupsProd, setBackupsProd] = useState([]);
  const [backupsStg, setBackupsStg] = useState([]);
  const [selectedBackupProd, setSelectedBackupProd] = useState(null);
  const [selectedBackupStg, setSelectedBackupStg] = useState(null);

  const fetchStatus = async () => {
    const res = await fetch('/api/task_status', {
      credentials: 'include'
    });

    if (res.ok) {
      const data = await res.json();
      setStatus(data.status);
      setLog(data.log || []);
      if (data.status !== "running" && pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  useEffect(() => {
    if (status === "running" && !pollingRef.current) {
      pollingRef.current = setInterval(fetchStatus, 1000);
    }
    if (status !== "running" && pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }
  }, [status]);

  const startProdStgMigration = async () => {
    const res = await fetch('/api/migrate_data', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ env: "PROD" })
    });

    const data = await res.json();
    if (res.ok) {
      setStatus("running");
      setLog([]);
      pollingRef.current = setInterval(fetchStatus, 1000);
    } else {
      alert(data.error);
    }
  };

  const startStgProdMigration = async () => {
    const res = await fetch('/api/migrate_data', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ env: "STG" })
    });

    const data = await res.json();
    if (res.ok) {
      setStatus("running");
      setLog([]);
      pollingRef.current = setInterval(fetchStatus, 1000);
    } else {
      alert(data.error);
    }
  };



  const maintenanceModeProd = async () => {
    const res = await fetch('/api/maintenance_mode', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ env: "PROD" })
    });

    const data = await res.json();
    if (res.ok) {
      setStatus("running");
      setLog([]);
      pollingRef.current = setInterval(fetchStatus, 1000);
    } else {
      alert(data.error);
    }
  };

  const maintenanceModeStg = async () => {
    const res = await fetch('/api/maintenance_mode', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ env: "STG" })
    });

    const data = await res.json();
    if (res.ok) {
      setStatus("running");
      setLog([]);
      pollingRef.current = setInterval(fetchStatus, 1000);
    } else {
      alert(data.error);
    }
  };




  const makeBackupProd = async () => {
    const res = await fetch('/api/make_backup', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ env: "PROD" })
    });

    const data = await res.json();
    if (res.ok) {
      setStatus("running");
      setLog([]);
      pollingRef.current = setInterval(fetchStatus, 1000);
    } else {
      alert(data.error);
    }
  };

  const makeBackupStg = async () => {
    const res = await fetch('/api/make_backup', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ env: "STG" })
    });

    const data = await res.json();
    if (res.ok) {
      setStatus("running");
      setLog([]);
      pollingRef.current = setInterval(fetchStatus, 1000);
    } else {
      alert(data.error);
    }
  };

  const fetchBackups = async () => {
    const fetchForEnv = async (env) => {
      const res = await fetch(`/api/list_backups?env=${env}`, {
        credentials: 'include'
      });
      const data = await res.json();
      return data.backups || [];
    };

    setBackupsProd(await fetchForEnv("PROD"));
    setBackupsStg(await fetchForEnv("STG"));
  };

  const restoreBackupProd = async () => {
    const res = await fetch('/api/restore_backup', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ env: "PROD", filename: selectedBackupProd })
    });

    const data = await res.json();
    if (res.ok) {
      setStatus("running");
      setLog([]);
      pollingRef.current = setInterval(fetchStatus, 1000);
    } else {
      alert(data.error);
    }
  };

  const restoreBackupStg = async () => {
    const res = await fetch('/api/restore_backup', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ env: "STG", filename: selectedBackupStg })
    });

    const data = await res.json();
    if (res.ok) {
      setStatus("running");
      setLog([]);
      pollingRef.current = setInterval(fetchStatus, 1000);
    } else {
      alert(data.error);
    }
  };



  useEffect(() => {
    fetchBackups();
  }, []);





  const logout = async () => {
    await fetch('/api/logout', {
      method: 'POST',
      credentials: 'include'
    });
    onLogout();
  };

  return (
    <div className="container mt-5">

      <div className="header-row">
        <h2>Panel użytkownika</h2>
        <button onClick={logout} className="btn btn-danger">Wyloguj</button>
      </div>

      <div className="row">
        {/* Kolumna Produkcja */}
        <div className="col-md-6">
          <h3 className="mb-3">Produkcja</h3>

          {/* Migracja danych */}
          <section className="mb-4 section-box">
            <h4 className="section-title">Migracja danych</h4>
            <button onClick={startProdStgMigration} className="btn btn-primary w-100" disabled={status === "running"}>
           [ PROD ➜ STG ] Przenieś dane
            </button>
          </section>

          {/* Maintenance mode */}
          <section className="mb-4 section-box">
            <h4 className="section-title">Maintenance mode</h4>
            <button onClick={maintenanceModeProd} className="btn btn-primary w-100" disabled={status === "running"}>
              [ PROD ] Włącz/Wyłącz maintenance mode
            </button>
          </section>

          {/* Tworzenie backupów */}
          <section className="mb-4 section-box">
            <h4 className="section-title">Tworzenie backupów</h4>
            <button onClick={makeBackupProd} className="btn btn-primary w-100" disabled={status === "running"}>
              [ PROD ] Zrób backup
            </button>
          </section>

          {/* Odtwarzanie backupów */}
          <section className="mb-4 section-box">
            <h4 className="section-title">Backupy produkcji</h4>
            {backupsProd.length === 0 ? <p>Brak backupów</p> : (
              <ul className="backup-list">
                {backupsProd.map(backup => (
                  <li key={backup}>
                    <input
                      type="radio"
                      name="backupProd"
                      disabled={status === "running"}
                      checked={selectedBackupProd === backup}
                      onChange={() => setSelectedBackupProd(backup)}
                    /> {backup}
                  </li>
                ))}
              </ul>
            )}
            {selectedBackupProd && (
              <button
                disabled={status === "running"}
                className="btn btn-warning btn-restore mt-2 w-100 "
                onClick={restoreBackupProd}
              >
                [ PROD ] Przywróć wybrany backup
              </button>
            )}
          </section>
        </div>

        {/* Kolumna Staging */}
        <div className="col-md-6">
          <h3 className="mb-3">Staging</h3>

          {/* Migracja danych */}
          <section className="mb-4 section-box">
            <h4 className="section-title">Migracja danych</h4>
            <button onClick={startStgProdMigration} className="btn btn-primary w-100" disabled={status === "running"}>
            [ STG ➜ PROD ] Przenieś dane
            </button>
          </section>

          {/* Maintenance mode */}
          <section className="mb-4 section-box">
            <h4 className="section-title">Maintenance mode</h4>
            <button onClick={maintenanceModeStg} className="btn btn-primary w-100" disabled={status === "running"}>
              [ STG ]  Włącz/Wyłącz maintenance mode
            </button>
          </section>

          {/* Tworzenie backupów */}
          <section className="mb-4 section-box">
            <h4 className="section-title">Tworzenie backupów</h4>
            <button onClick={makeBackupStg} className="btn btn-primary w-100" disabled={status === "running"}>
              [ STG ]  Zrób backup
            </button>
          </section>

          {/* Odtwarzanie backupów */}
          <section className="mb-4 section-box">
            <h4 className="section-title">Backupy stagingu</h4>
            {backupsStg.length === 0 ? <p>Brak backupów</p> : (
              <ul className="backup-list">
                {backupsStg.map(backup => (
                  <li key={backup}>
                    <input
                      type="radio"
                      name="backupStg"
                      disabled={status === "running"}
                      checked={selectedBackupStg === backup}
                      onChange={() => setSelectedBackupStg(backup)}
                    /> {backup}
                  </li>
                ))}
              </ul>
            )}
            {selectedBackupStg && (
              <button
                disabled={status === "running"}
                className="btn btn-warning btn-restore mt-5 w-100"
                onClick={restoreBackupStg}
              >
                [ STG ] Przywróć wybrany backup
              </button>
            )}
          </section>
        </div>
      </div>

      {/* Terminal logi */}
      <section className="mt-5">
        <div className="card shadow-sm">
          <div className="card-header bg-dark text-white">
            Status: <strong>{status}</strong>
          </div>
          <div
            className="card-body terminal-log"
            style={{ whiteSpace: 'pre-wrap', maxHeight: '300px', overflowY: 'auto', fontFamily: 'monospace' }}
          >
            {log.length > 0 ? (
              log.map((line, idx) => {
                const tagRegex = /\((cmd|name|path|count|env)\)(.*?)\(\/\1\)/g;
                const parts = [];
                let lastIndex = 0;
                let match;
                let keyIndex = 0;

                while ((match = tagRegex.exec(line)) !== null) {
                  const [fullMatch, tag, content] = match;
                  const start = match.index;
                  const end = tagRegex.lastIndex;

                  // Zwykły tekst przed znacznikiem
                  if (start > lastIndex) {
                    parts.push(
                      <span key={`${idx}-text-${keyIndex++}`}>
                        {line.substring(lastIndex, start)}
                      </span>
                    );
                  }

                  // Fragment ze znacznikiem
                  parts.push(
                    <code className={`${tag}-block`} key={`${idx}-${tag}-${keyIndex++}`}>
                      {content}
                    </code>
                  );

                  lastIndex = end;
                }

                // Zwykły tekst po ostatnim znaczniku
                if (lastIndex < line.length) {
                  parts.push(
                    <span key={`${idx}-text-${keyIndex++}`}>
                      {line.substring(lastIndex)}
                    </span>
                  );
                }

                return <div key={idx}>{parts}</div>;
              })
            ) : (
              "Brak logów"
            )}


          </div>
        </div>
      </section>
    </div>
  );


}
